module.exports = __webpack_public_path__ + "img/no-docs.be644486.svg";